import React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import './coursePack.module.scss';
import RoleModelCard1 from './images/shares-4931105.png';
import RoleModelCard2 from './images/shares-4929995.png';
import RoleModelCard3 from './images/shares-4929970.png';
import PatternLeft from './images/pattern-left-green.png';
import PatternRight from './images/pattern-right-green.png';
import SheHirameki from './images/she-hirameki.png';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import classNames from 'classnames';
import {
  CourseSmallBrandingCard,
  CourseSmallBusinessCard,
  CourseSmallDesignExerciseCard,
  CourseSmallDirectorCard,
  CourseSmallIllustratorCard,
  CourseSmallLogoCICard,
  CourseSmallMarketingFirstCard,
  CourseSmallProjectManagementCard,
  CourseSmallUIUXCard,
  CourseSmallWebMarketingCard,
  CourseSmallWordPressCard,
  CourseWebDesignCard,
  CourseWebDesignFirstCard,
} from './CourseCard';
import { V3Routes } from '../../routes';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

@withNavigation(NavigationSpecs.side())
@authenticated
export class DesignerPage extends React.Component {
  render() {
    const breadCrumbItems = [{ text: 'コース', to: V3Routes.courses() }, { text: 'Webデザイナーセット' }];
    return (
      <>
        <div styleName={classNames('head', 'designer')}>
          <div styleName="head-inner">
            <BreadCrumb items={breadCrumbItems} hasHome />
            <div styleName="head-content">
              <div styleName={classNames('course-title', 'designer')}>Webデザイナーセット</div>
              <div styleName="head-detail">
                <div styleName="description">
                  Webサイトをデザインするための基本的な知識やスキルを身につけながら、自分の興味や強みを活かしたデザイナーを目指すためのセットです。Webデザインだけに留まらず、Webデザインの知識を活かした別職種に転身する方や、Webサイト以外のデザインに取り組む方もいます。
                </div>
                <div styleName={classNames('comment', 'designer')}>
                  <div styleName="label-box">
                    <div styleName={classNames('label', 'designer')}>こんなひとにおすすめ</div>
                  </div>
                  <img src={SheHirameki} styleName="she-image" />
                  <ul styleName="comment-text">
                    <li>デザインを仕事にしたい</li>
                    <li>デザインスキルを応用したい</li>
                    <li>ものづくりが好き</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName={classNames('content-bg', 'designer')}>
          <div styleName="content">
            <p styleName="title">必修コース</p>
            <p styleName="sub-title">必ず受けておきたいコース</p>
            <div styleName="main-course-list">
              <CourseWebDesignFirstCard />
              <CourseWebDesignCard />
            </div>
            <div styleName="title">選択コース</div>
            <div styleName="sub-title">なりたい姿に合わせて追加で受けておきたいコース</div>
            <div styleName={classNames('pattern-bg', 'designer')}>
              {GlobalStatesV3.viewport.isMobile && (
                <div styleName="pattern">
                  <span>
                    <img src={PatternLeft} styleName="pattern-left" />
                  </span>
                  <span styleName={classNames('label', 'designer')}>先輩シーメイトたちの受講パターン</span>
                  <span>
                    <img src={PatternRight} styleName="pattern-right" />
                  </span>
                </div>
              )}
              {GlobalStatesV3.viewport.isDesktop && (
                <>
                  <img src={PatternLeft} styleName="pattern-left" />
                  <img src={PatternRight} styleName="pattern-right" />
                  <div styleName="pattern">
                    <div styleName={classNames('label', 'designer')}>先輩シーメイトたちの受講パターン</div>
                  </div>
                </>
              )}
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'designer')}>パターン1</span>
                <span styleName="pattern-text">いろいろデザインできるデザイナーになりたい</span>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'designer')}>パターン2</span>
                <span styleName="pattern-text">デザインの知識を活かして、モノやサービスを魅せることに関わりたい</span>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'designer')}>パターン3</span>
                <span styleName="pattern-text">
                  デザインのわかるWebディレクターとして、プロジェクトの進行に携わりたい
                </span>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン1</p>
              {GlobalStatesV3.viewport.isMobile && (
                <p styleName="pattern-label designer">いろいろデザインできるデザイナーになりたい</p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isDesktop && (
                  <p styleName="pattern-label designer">いろいろデザインできるデザイナーになりたい</p>
                )}
                <p styleName="description sp-space">
                  バナーやWebサイトのデザインをするための基礎知識を身につけた上で、より幅広くデザインスキルを身につけるためのコースを受講していきます。Web上のデザインに留まらず、チラシや名刺などの紙もののデザインや、ロゴなどのグラフィックデザインにも挑戦できます。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallDesignExerciseCard />
                      <CourseSmallIllustratorCard />
                      <CourseSmallWordPressCard />
                      <CourseSmallLogoCICard />
                      <CourseSmallUIUXCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4931105" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard1} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン2</p>
              {GlobalStatesV3.viewport.isMobile && (
                <p styleName="pattern-label designer">
                  デザインの知識を活かして、モノやサービスを魅せることに関わりたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isDesktop && (
                  <p styleName="pattern-label designer">
                    デザインの知識を活かして、モノやサービスを魅せることに関わりたい
                  </p>
                )}
                <p styleName="description sp-space">
                  Webサイトのデザインスキルをベースに、モノやサービスを売るための企画や戦略立てについて学べるコースを受講していきます。マーケティング関連のコースやブランディングコースも受けることで、ビジネス観点でのデザインの活用法を学ぶことができます。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallMarketingFirstCard />
                      <CourseSmallWebMarketingCard />
                      <CourseSmallBrandingCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4929995" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard2} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン3</p>
              {GlobalStatesV3.viewport.isMobile && (
                <p styleName="pattern-label designer">
                  デザインのわかるWebディレクターとして、プロジェクトの進行に携わりたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isDesktop && (
                  <p styleName="pattern-label designer">
                    デザインのわかるWebディレクターとして、プロジェクトの進行に携わりたい
                  </p>
                )}
                <p styleName="description sp-space">
                  Webサイトのデザインをするための知識を身につけたのち、プロジェクト全体を指揮する際に必要なチームマネジメントのスキルを習得することで、クライアントにもプロジェクトメンバーにも信頼されるディレクターを目指すことができます。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallWordPressCard />
                      <CourseSmallDirectorCard />
                      <CourseSmallProjectManagementCard />
                      <CourseSmallBusinessCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4929970" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard3} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
